

class VatEvent extends CustomEvent {
    /**
     * @param {boolean} vatIncluded
     */
    constructor( vatIncluded ) {
        super( 'vat-change', { detail: vatIncluded } );
    }
}


class VATSwitchHTMLElement extends HTMLElement {
    static observedAttributes = ['vat-included'];

    static template = `
        <style>
            /* The switch - the box around the slider */
            .switch {
                position: relative;
                display: inline-block;
                width: 6.75rem;
                height: 2.25rem;
                cursor: pointer;
                user-select: none;
            }

            /* Hide default HTML checkbox */
            .switch__checkbox {
                opacity: 0;
                width: 0;
                height: 0;
            }

            /* The slider */
            .switch__slider {
                display: block;
                position: absolute;
                inset: 0;
                border-radius: 100rem;
                background-color: transparent;
                border: 2px solid var(--color-btn-bd);
                transition: .4s ease-in-out;
                outline: 3px solid transparent;
            }

            .switch__slider:before {
                display: block;
                position: absolute;
                content: "";
                height: 1rem;
                width: 1rem;
                border-radius: 50%;
                z-index: 5;
                top: 50%;
                left: 0.75rem;
                transform: translate(0%, -50%);
                background-color: var(--color-btn);
                -webkit-transition: .4s;
                transition: .4s;
                box-shadow: 0 1px 0.25rem #0002;
            }

            .switch__checkbox:checked + .switch__slider {
                background-color: var(--color-btn-bg);
            }

            .switch__checkbox:focus-visible + .switch__slider {
                outline: 3px solid var(--color-link);
            }

            .switch__yes, .switch__no {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                font-size: 84%;
                font-weight: 500;
                line-height: 1;
                z-index: 2;
                transition: 300ms ease;
                transition-property: color, opacity, visibility;
                transition-behavior: allow-discrete;
            }

            .switch__yes {
                opacity: 0;
                visibility: hidden;
                left: 1rem;
                color: var(--color-btn);
            }

            .switch__no {
                right: 1rem;
                color: var(--color-btn-hv);
            }

            .switch__checkbox:checked ~ .switch__yes {
                opacity: 1;
                visibility: visible;
            }

            .switch__checkbox:checked ~ .switch__no {
                opacity: 0;
                visibility: hidden;
            }

            .switch__checkbox:checked + .switch__slider:before {
                -webkit-transform: translate(4rem, -50%);
                -ms-transform: translate(4rem, -50%);
                transform: translate(4rem, -50%);
            }
        </style>
        <label class="switch">
            <input id="input" class="switch__checkbox" type="checkbox">
            <span class="switch__slider"></span>
            <span class="switch__yes">INC VAT</span>
            <span class="switch__no">EXC VAT</span>
        </label>
    `;

    constructor() {
        super();
    }

    connectedCallback() {
        const shadow = this.attachShadow( { mode: 'closed' } );
        shadow.innerHTML = VATSwitchHTMLElement.template;
        this.input = /** @type {HTMLInputElement} */ shadow.getElementById( 'input' );

        this.setAttribute( 'vat-included', isVatIncluded().toString() );

        this.input?.addEventListener( 'input', () => {
            setVat( this.input.checked );
        } );

        document.addEventListener( 'vat-change', ( /** @type {VatEvent} */ event ) => {
            const newValue = event.detail;
            this.setAttribute( 'vat-included', newValue.toString() );
        } );
    }

    disconnectedCallback() {

    }

    /**
     * @param {string} name
     * @param {string} oldVal
     * @param {string} newVal
     */
    attributeChangedCallback( name, oldVal, newVal ) {
        switch ( name ) {
            case 'vat-included':
                this.input.checked = newVal === 'true';
                break;
        }
    }
}

customElements.define( 'nu-vat-switch', VATSwitchHTMLElement );

/**
 * @param {boolean} isVatIncluded
 *
 * @return void
 */
export function setVat( isVatIncluded ) {
    if ( isVatIncluded !== true && isVatIncluded !== false ) return console.warn( 'Tried to set vat-included as non boolean!' );

    document.dispatchEvent( new VatEvent( isVatIncluded ) );

    document.body.classList.toggle( 'has-vat-included', isVatIncluded );
    document.body.classList.toggle( 'has-vat-excluded', !isVatIncluded );

    sessionStorage.setItem( 'nuwoo-product-vat-included', isVatIncluded.toString() );
}

/**
 * Get whether vat is currently included
 *
 * @return {boolean} is VAT currently included?
 */
export function isVatIncluded() {
    return sessionStorage.getItem( 'nuwoo-product-vat-included' ) === 'true';
}